import { render } from "./imgNoticeDetail.vue?vue&type=template&id=562f5380"
import script from "./imgNoticeDetail.vue?vue&type=script&lang=js"
export * from "./imgNoticeDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__